import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLang } from "@/i18n/LanguageContext";

export default function Faq() {
  const { t } = useLang();
  const faqs = t("faq.items");

  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-[#FAF6EE]">
      <div className="max-w-3xl mx-auto px-4 sm:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#7A571C] mb-3 text-center">{t("faq.eyebrow")}</p>
        <h2 className="font-display font-medium text-3xl sm:text-4xl tracking-tight text-[#0B2E4A] text-center text-balance mb-10">
          {t("faq.title")}
        </h2>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {Array.isArray(faqs) && faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-[#E6DED1] rounded-2xl px-6 overflow-hidden"
            >
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display font-semibold text-base sm:text-lg text-[#0B2E4A] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#56636D] text-sm sm:text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
